import axios from './_defaults/v2/user';

export async function getReviews({params}) {
    try {
        const response = await axios.get(`/reviews`, { params });

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.response?.status === 404) return [];
        throw error;
    }
}

export async function getReviewsCounter({ params }) {
    try {
        const response = await axios.get(`/reviews/count`, { params });

        if (response.data) {
            return response.data[0];
        }
    } catch (error) {
        if (error.response?.status === 404) return {};
        console.log(error.response);
        throw error;
    }
}

export async function getReview({ reviewId, params }) {
    try {
        const response = await axios.get(`/reviews/${reviewId}`, { params });

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.response?.status === 404) return [];
        console.log(error.response);
        throw error;
    }
}

export async function createReview({ data }) {
    try {
        const response = await axios.post(`/reviews`, data);

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.response?.status === 404) return [];
        throw error;
    }
}
